module.exports = __webpack_public_path__ + "static/media/pan.11f5701e.png";